export type TrackingIds = {
  [K in "Starter" | "Team" | "Business" | "Enterprise"]: string;
};

export const getFeaturesMatrixTrackingId = (name: keyof TrackingIds, number = 2): string => {
  const paddedNumber = number.toString().padStart(2, "0");
  const planPrefix = name.toLowerCase();
  return `${planPrefix}-cta-${paddedNumber}`;
};

export const getTrackingIdForFeaturesMatrixPlan = (name: keyof TrackingIds): string => {
  return getFeaturesMatrixTrackingId(name, 2); // Using 2 to maintain "plan-cta-02" pattern
};
